import { FC } from 'react';
import DocumentLinkIcon from '../icons/DocumentLinkIcon';
import { IDocument } from '../types';

interface IProps {
  status: 'done' | 'inprogress' | 'notavailable';
  title: string;
  documents: {
    pdf?: IDocument;
    doc?: IDocument;
    xls?: IDocument;
    xbrl?: IDocument;
  };
}

const MobileFinancialAnnualDocuments: FC<IProps> = ({
  status,
  documents,
  title,
}) => {
  const renderDocuments = () => {
    let result: React.ReactNode | null = null;
    switch (status) {
      case 'inprogress':
        result = (
          <div className="financial-results__table--annual-report-not-available">
            In Progress
          </div>
        );
        break;

      case 'notavailable':
        result = (
          <div className="financial-results__table--annual-report-not-available">
            Not Available
          </div>
        );
        break;
      case 'done':
        result = (
          <div>
            {Object.entries(documents).map(([title, link]) => {
              if (!link) {
                return null;
              }
              return (
                <a
                  href={link}
                  key={title}
                  title={title}
                  className="financial-results__table--annual-report-link"
                >
                  <DocumentLinkIcon documentType={title} />
                </a>
              );
            })}
          </div>
        );
        break;
      default:
        result = null;
    }
    return result;
  };
  return (
    <div className="financial-results__table--mobile-calendar-row">
      <div>
        <div className="montserrat-12-bold financial-results__table--mobile-row-title">
          {title}
        </div>
        {renderDocuments()}
      </div>
    </div>
  );
};

export default MobileFinancialAnnualDocuments;
